import * as ReactService from "@intech/react-service";
import { WebAssuntoEntidade } from "../entidades/WebAssuntoEntidade";
import { RelacionamentoEntidade } from "../entidades/RelacionamentoEntidade";

class Relacionamento extends ReactService.BaseService {
  constructor() {
    super("Relacionamento");
  }

  ValidarEmail = (email: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `ValidarEmail/${email}`);

  BuscarListaAssunto = () =>
    this.CreateRequest<WebAssuntoEntidade[]>(ReactService.RequestType.GET, `BuscarListaAssunto`);

  Enviar = (relacionamentoEntidade: RelacionamentoEntidade) =>
    this.CreateRequest<string>(ReactService.RequestType.POST, `Enviar`, relacionamentoEntidade);

}

export const RelacionamentoService = new Relacionamento();
